import { render, staticRenderFns } from "./PurchaseIn.vue?vue&type=template&id=71269d6c&scoped=true&"
import script from "./PurchaseIn.vue?vue&type=script&lang=js&"
export * from "./PurchaseIn.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseIn.vue?vue&type=style&index=0&id=71269d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71269d6c",
  null
  
)

export default component.exports